import { GoogleMap, InfoWindow, Marker } from "@react-google-maps/api";
import { useRef, useState } from "react";

const Map = (props) => {
  const { isLoaded } = props;
  const mapRef = useRef(null);
  const [selectedMarker, setSelectedMarker] = useState("");
  const containerStyle = {
    width: "100%",
    height: "min(800px, 100vh)",
  };

  const panToMarker = (point) => {
    setSelectedMarker(point);

    requestAnimationFrame(() => {
      if (!mapRef.current) return;

      window.google.maps.event.trigger(mapRef.current, "resize");
      mapRef.current.panTo(point.location);
      mapRef.current.panBy(0, -100);
    });
  };

  const closeInfoWindow = () => {
    const location = selectedMarker?.location;
    setSelectedMarker("");

    if (!location) return;

    requestAnimationFrame(() => {
      mapRef.current?.panTo(location);
    });
  };

  const center = {
    lat: 53.380860904216355,
    lng: -1.4699408453424565,
  };
  const points = [
    {
      id: 353,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11112400001002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Baker Hughes - Newcastle - Employees Only
        </a>
      ),
      location: { lat: 54.96, lng: -1.54 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11112400001002&product=HOURLY_RENTAL",
    },
    {
      id: 355,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901000006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Imperial college
        </a>
      ),
      location: { lat: 51.49, lng: -0.17 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901000006&product=HOURLY_RENTAL",
    },
    {
      id: 357,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11111800002003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          St Modwen - Uxbridge
        </a>
      ),
      location: { lat: 53.2, lng: -0.61 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11111800002003&product=HOURLY_RENTAL",
    },
    {
      id: 358,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11090600001003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          The Lamptons [ Residents Only]
        </a>
      ),
      location: { lat: 51.5, lng: -0.12 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11090600001003&product=HOURLY_RENTAL",
    },
    {
      id: 359,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901935006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Aberdeen
        </a>
      ),
      location: { lat: 57.12, lng: -2.12 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901935006&product=HOURLY_RENTAL",
    },
    {
      id: 360,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902026004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Acton
        </a>
      ),
      location: { lat: 51.52, lng: -0.27 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902026004&product=HOURLY_RENTAL",
    },
    {
      id: 361,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901947002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Aintree
        </a>
      ),
      location: { lat: 53.48, lng: -2.94 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901947002&product=HOURLY_RENTAL",
    },
    {
      id: 362,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902027003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Ashford
        </a>
      ),
      location: { lat: 51.13, lng: 0.87 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902027003&product=HOURLY_RENTAL",
    },
    {
      id: 363,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19032100001008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Ashton Under Lyne
        </a>
      ),
      location: { lat: 53.4779244, lng: -2.1245041 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19032100001008&product=HOURLY_RENTAL",
    },
    {
      id: 364,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20121100001008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Aylesbury
        </a>
      ),
      location: { lat: 51.818264, lng: -0.806887 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20121100001008&product=HOURLY_RENTAL",
    },
    {
      id: 365,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901999009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Bamber Bridge
        </a>
      ),
      location: { lat: 53.72, lng: -2.66 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901999009&product=HOURLY_RENTAL",
    },
    {
      id: 366,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb17091200001008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Basildon
        </a>
      ),
      location: { lat: 51.580116, lng: 0.445411 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb17091200001008&product=HOURLY_RENTAL",
    },
    {
      id: 367,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901968006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Beckton
        </a>
      ),
      location: { lat: 51.52, lng: 0.07 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901968006&product=HOURLY_RENTAL",
    },
    {
      id: 368,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902000004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Belvedere
        </a>
      ),
      location: { lat: 51.49, lng: 0.15 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902000004&product=HOURLY_RENTAL",
    },
    {
      id: 369,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18102200005009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Bolton
        </a>
      ),
      location: { lat: 53.5864029, lng: -2.4268322 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18102200005009&product=HOURLY_RENTAL",
    },
    {
      id: 370,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902003001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Brighton
        </a>
      ),
      location: { lat: 50.84, lng: -0.12 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902003001&product=HOURLY_RENTAL",
    },
    {
      id: 371,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901938003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Bristol
        </a>
      ),
      location: { lat: 51.44, lng: -2.5 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901938003&product=HOURLY_RENTAL",
    },
    {
      id: 372,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13091700001006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Burgess Hill
        </a>
      ),
      location: { lat: 50.95, lng: -0.15 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13091700001006&product=HOURLY_RENTAL",
    },
    {
      id: 374,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902032006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Cambridge
        </a>
      ),
      location: { lat: 52.21, lng: 0.14 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902032006&product=HOURLY_RENTAL",
    },
    {
      id: 375,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902005009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Cardiff Culverhouse Cross
        </a>
      ),
      location: { lat: 51.46, lng: -3.26 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902005009&product=HOURLY_RENTAL",
    },
    {
      id: 376,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23032000001002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Cardiff Gate
        </a>
      ),
      location: { lat: 51.5371132, lng: -3.128686 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23032000001002&product=HOURLY_RENTAL",
    },
    {
      id: 377,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22032900001005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Cheetham Hill
        </a>
      ),
      location: { lat: 53.4983788, lng: -2.2367752 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22032900001005&product=HOURLY_RENTAL",
    },
    {
      id: 378,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb15102700002007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Chelmsford
        </a>
      ),
      location: { lat: 51.746513, lng: 0.50776 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb15102700002007&product=HOURLY_RENTAL",
    },
    {
      id: 379,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902036002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Cheltenham
        </a>
      ),
      location: { lat: 51.89, lng: -2.13 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902036002&product=HOURLY_RENTAL",
    },
    {
      id: 380,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901980000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Chester
        </a>
      ),
      location: { lat: 53.19, lng: -2.91 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901980000&product=HOURLY_RENTAL",
    },
    {
      id: 381,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23033100001009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Chingford
        </a>
      ),
      location: { lat: 51.6087298, lng: -0.0296273 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23033100001009&product=HOURLY_RENTAL",
    },
    {
      id: 382,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901898001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Chiswick
        </a>
      ),
      location: { lat: 51.49, lng: -0.28 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901898001&product=HOURLY_RENTAL",
    },
    {
      id: 383,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902007007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Coatbridge
        </a>
      ),
      location: { lat: 55.85, lng: -4.01 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902007007&product=HOURLY_RENTAL",
    },
    {
      id: 384,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb21111600001007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Colchester Tollgate
        </a>
      ),
      location: { lat: 51.8879356, lng: 0.82715893 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb21111600001007&product=HOURLY_RENTAL",
    },
    {
      id: 385,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901906001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Coventry
        </a>
      ),
      location: { lat: 52.39, lng: -1.43 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901906001&product=HOURLY_RENTAL",
    },
    {
      id: 386,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902066005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Crawley
        </a>
      ),
      location: { lat: 51.12, lng: -0.18 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902066005&product=HOURLY_RENTAL",
    },
    {
      id: 387,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902009005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Crewe
        </a>
      ),
      location: { lat: 53.08, lng: -2.42 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902009005&product=HOURLY_RENTAL",
    },
    {
      id: 388,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901899000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Cribbs Causeway
        </a>
      ),
      location: { lat: 51.52, lng: -2.6 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901899000&product=HOURLY_RENTAL",
    },
    {
      id: 389,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901900007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Cricklewood
        </a>
      ),
      location: { lat: 51.55, lng: -0.21 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901900007&product=HOURLY_RENTAL",
    },
    {
      id: 390,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901966008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Croydon
        </a>
      ),
      location: { lat: 51.38, lng: -0.12 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901966008&product=HOURLY_RENTAL",
    },
    {
      id: 391,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901946003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Darnley
        </a>
      ),
      location: { lat: 55.8, lng: -4.34 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901946003&product=HOURLY_RENTAL",
    },
    {
      id: 392,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb21060100001009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Dearne Valley
        </a>
      ),
      location: { lat: 53.5065239, lng: -1.3871019 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb21060100001009&product=HOURLY_RENTAL",
    },
    {
      id: 393,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901953003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Derby
        </a>
      ),
      location: { lat: 52.89, lng: -1.47 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901953003&product=HOURLY_RENTAL",
    },
    {
      id: 394,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901944005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Doncaster
        </a>
      ),
      location: { lat: 53.49, lng: -1.11 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901944005&product=HOURLY_RENTAL",
    },
    {
      id: 395,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902011001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Dundee
        </a>
      ),
      location: { lat: 56.48, lng: -3 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902011001&product=HOURLY_RENTAL",
    },
    {
      id: 396,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901952004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q East Kilbride
        </a>
      ),
      location: { lat: 55.78, lng: -4.16 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901952004&product=HOURLY_RENTAL",
    },
    {
      id: 397,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23030800001007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Eastleigh
        </a>
      ),
      location: { lat: 50.97689, lng: -1.363417 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23030800001007&product=HOURLY_RENTAL",
    },
    {
      id: 398,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901936005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Edinburgh
        </a>
      ),
      location: { lat: 55.93, lng: -3.09 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901936005&product=HOURLY_RENTAL",
    },
    {
      id: 399,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22042700001007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Eltham
        </a>
      ),
      location: { lat: 51.445733, lng: 0.061954 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22042700001007&product=HOURLY_RENTAL",
    },
    {
      id: 400,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22113000001006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Enfield
        </a>
      ),
      location: { lat: 51.6540718, lng: -0.0569539 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22113000001006&product=HOURLY_RENTAL",
    },
    {
      id: 401,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23021400002006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Erdington
        </a>
      ),
      location: { lat: 52.5121574, lng: -1.7987167 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23021400002006&product=HOURLY_RENTAL",
    },
    {
      id: 402,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901933008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Farnborough
        </a>
      ),
      location: { lat: 51.29, lng: -0.76 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901933008&product=HOURLY_RENTAL",
    },
    {
      id: 403,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901937004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Gillingham
        </a>
      ),
      location: { lat: 51.36, lng: 0.57 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901937004&product=HOURLY_RENTAL",
    },
    {
      id: 404,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902069002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Glasshoughton
        </a>
      ),
      location: { lat: 53.7, lng: -1.33 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902069002&product=HOURLY_RENTAL",
    },
    {
      id: 405,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901976006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Gloucester
        </a>
      ),
      location: { lat: 51.87, lng: -2.24 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901976006&product=HOURLY_RENTAL",
    },
    {
      id: 406,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23021400001007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Gravesend
        </a>
      ),
      location: { lat: 51.4446964, lng: 0.36119274 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23021400001007&product=HOURLY_RENTAL",
    },
    {
      id: 407,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19061800001007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Great Western Road
        </a>
      ),
      location: { lat: 55.904336, lng: -4.378603 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19061800001007&product=HOURLY_RENTAL",
    },
    {
      id: 408,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901975007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Greenwich
        </a>
      ),
      location: { lat: 51.48, lng: 0.01 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901975007&product=HOURLY_RENTAL",
    },
    {
      id: 409,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19100700001002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Guildford
        </a>
      ),
      location: { lat: 51.2490925, lng: -0.5821099 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19100700001002&product=HOURLY_RENTAL",
    },
    {
      id: 410,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901907000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Halesowen
        </a>
      ),
      location: { lat: 52.45, lng: -2.03 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901907000&product=HOURLY_RENTAL",
    },
    {
      id: 411,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22021600001004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Handforth
        </a>
      ),
      location: { lat: 53.3577272, lng: -2.2004125 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22021600001004&product=HOURLY_RENTAL",
    },
    {
      id: 412,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902070009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Hartcliffe
        </a>
      ),
      location: { lat: 51.41, lng: -2.59 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902070009&product=HOURLY_RENTAL",
    },
    {
      id: 413,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901965009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Havant
        </a>
      ),
      location: { lat: 50.86, lng: -1.01 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901965009&product=HOURLY_RENTAL",
    },
    {
      id: 414,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901969005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Hedge End
        </a>
      ),
      location: { lat: 50.92, lng: -1.3 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901969005&product=HOURLY_RENTAL",
    },
    {
      id: 415,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23032100001000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Hemel Hempstead
        </a>
      ),
      location: { lat: 51.743003, lng: -0.473259 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23032100001000&product=HOURLY_RENTAL",
    },
    {
      id: 416,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901945004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Hermiston Gait
        </a>
      ),
      location: { lat: 55.92, lng: -3.3 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901945004&product=HOURLY_RENTAL",
    },
    {
      id: 417,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb15110400001005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q High Wycombe
        </a>
      ),
      location: { lat: 51.6172028, lng: -0.7140303 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb15110400001005&product=HOURLY_RENTAL",
    },
    {
      id: 418,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901916009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Huddersfield
        </a>
      ),
      location: { lat: 53.65, lng: -1.76 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901916009&product=HOURLY_RENTAL",
    },
    {
      id: 419,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb15092400001007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Ilford
        </a>
      ),
      location: { lat: 51.574218, lng: 0.082235 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb15092400001007&product=HOURLY_RENTAL",
    },
    {
      id: 420,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902072007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Inverness
        </a>
      ),
      location: { lat: 57.48, lng: -4.22 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902072007&product=HOURLY_RENTAL",
    },
    {
      id: 421,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18052200002002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Kidderminster
        </a>
      ),
      location: { lat: 52.3818359, lng: -2.2475405 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18052200002002&product=HOURLY_RENTAL",
    },
    {
      id: 422,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20022500001009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Leatherhead
        </a>
      ),
      location: { lat: 51.31255, lng: -0.3341 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20022500001009&product=HOURLY_RENTAL",
    },
    {
      id: 423,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23030700004006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Leeds Beeston Ring Road
        </a>
      ),
      location: { lat: 53.7732086, lng: -1.5834436 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23030700004006&product=HOURLY_RENTAL",
    },
    {
      id: 424,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23030700005005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Leeds Killingbeck
        </a>
      ),
      location: { lat: 53.8066177, lng: -1.4782406 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23030700005005&product=HOURLY_RENTAL",
    },
    {
      id: 425,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901918007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Leicester
        </a>
      ),
      location: { lat: 52.64, lng: -1.14 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901918007&product=HOURLY_RENTAL",
    },
    {
      id: 426,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902044002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Leyton
        </a>
      ),
      location: { lat: 51.55, lng: 0 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902044002&product=HOURLY_RENTAL",
    },
    {
      id: 427,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901974008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Lincoln
        </a>
      ),
      location: { lat: 53.22, lng: -0.55 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901974008&product=HOURLY_RENTAL",
    },
    {
      id: 428,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb17062100003003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Liverpool
        </a>
      ),
      location: { lat: 53.4094353, lng: -2.9155793 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb17062100003003&product=HOURLY_RENTAL",
    },
    {
      id: 429,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902074005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Loughborough
        </a>
      ),
      location: { lat: 52.77, lng: -1.2 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902074005&product=HOURLY_RENTAL",
    },
    {
      id: 430,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901924009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Luton
        </a>
      ),
      location: { lat: 51.88, lng: -0.45 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901924009&product=HOURLY_RENTAL",
    },
    {
      id: 431,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901912003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Meir Park
        </a>
      ),
      location: { lat: 52.97, lng: -2.09 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901912003&product=HOURLY_RENTAL",
    },
    {
      id: 432,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb21051900001003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Middlesbrough
        </a>
      ),
      location: { lat: 54.569887, lng: -1.178911 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb21051900001003&product=HOURLY_RENTAL",
    },
    {
      id: 433,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901927006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Milton Keynes
        </a>
      ),
      location: { lat: 52.03, lng: -0.78 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901927006&product=HOURLY_RENTAL",
    },
    {
      id: 434,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901934007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q New Malden
        </a>
      ),
      location: { lat: 51.39, lng: -0.24 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901934007&product=HOURLY_RENTAL",
    },
    {
      id: 435,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901970002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q North Shields
        </a>
      ),
      location: { lat: 55, lng: -1.5 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901970002&product=HOURLY_RENTAL",
    },
    {
      id: 436,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901926007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Northampton
        </a>
      ),
      location: { lat: 52.23, lng: -0.9 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901926007&product=HOURLY_RENTAL",
    },
    {
      id: 437,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901940009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Nottingham
        </a>
      ),
      location: { lat: 52.93, lng: -1.16 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901940009&product=HOURLY_RENTAL",
    },
    {
      id: 438,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901977005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Nursling
        </a>
      ),
      location: { lat: 50.93, lng: -1.47 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901977005&product=HOURLY_RENTAL",
    },
    {
      id: 439,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901978004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Oldham
        </a>
      ),
      location: { lat: 53.55, lng: -2.12 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901978004&product=HOURLY_RENTAL",
    },
    {
      id: 440,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb21112600001006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Oxford
        </a>
      ),
      location: { lat: 51.7550774, lng: -1.29504 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb21112600001006&product=HOURLY_RENTAL",
    },
    {
      id: 441,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901921002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Paisley
        </a>
      ),
      location: { lat: 55.86, lng: -4.41 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901921002&product=HOURLY_RENTAL",
    },
    {
      id: 442,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902017005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Parkhead
        </a>
      ),
      location: { lat: 55.85, lng: -4.2 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902017005&product=HOURLY_RENTAL",
    },
    {
      id: 443,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902024006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Peckham
        </a>
      ),
      location: { lat: 51.48, lng: -0.06 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902024006&product=HOURLY_RENTAL",
    },
    {
      id: 444,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902065006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Peterborough
        </a>
      ),
      location: { lat: 52.59, lng: -0.26 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902065006&product=HOURLY_RENTAL",
    },
    {
      id: 445,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901939002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Plymouth
        </a>
      ),
      location: { lat: 50.41, lng: -4.12 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901939002&product=HOURLY_RENTAL",
    },
    {
      id: 446,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901901006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Poole
        </a>
      ),
      location: { lat: 50.73, lng: -1.98 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901901006&product=HOURLY_RENTAL",
    },
    {
      id: 447,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902075004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Portsmouth
        </a>
      ),
      location: { lat: 50.79, lng: -1.06 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902075004&product=HOURLY_RENTAL",
    },
    {
      id: 448,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901954002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Queens Road
        </a>
      ),
      location: { lat: 53.37, lng: -1.46 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901954002&product=HOURLY_RENTAL",
    },
    {
      id: 449,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901964000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Reading
        </a>
      ),
      location: { lat: 51.42, lng: -0.98 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901964000&product=HOURLY_RENTAL",
    },
    {
      id: 450,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901919006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Romford
        </a>
      ),
      location: { lat: 51.59, lng: 0.22 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901919006&product=HOURLY_RENTAL",
    },
    {
      id: 451,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901973009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Scotswood
        </a>
      ),
      location: { lat: 54.97, lng: -1.69 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901973009&product=HOURLY_RENTAL",
    },
    {
      id: 452,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22072000001005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Sidcup
        </a>
      ),
      location: { lat: 51.520484, lng: -0.635464 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22072000001005&product=HOURLY_RENTAL",
    },
    {
      id: 453,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901971001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Slough
        </a>
      ),
      location: { lat: 51.52, lng: -0.63 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901971001&product=HOURLY_RENTAL",
    },
    {
      id: 454,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901928005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Southend
        </a>
      ),
      location: { lat: 51.55, lng: 0.72 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901928005&product=HOURLY_RENTAL",
    },
    {
      id: 455,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18082300001005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Speke
        </a>
      ),
      location: { lat: 53.3510094, lng: -2.8767521 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18082300001005&product=HOURLY_RENTAL",
    },
    {
      id: 456,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb21042700003007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q St Albans
        </a>
      ),
      location: { lat: 53.445836, lng: -2.734172 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb21042700003007&product=HOURLY_RENTAL",
    },
    {
      id: 457,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902019003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q St Helens
        </a>
      ),
      location: { lat: 53.44, lng: -2.73 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902019003&product=HOURLY_RENTAL",
    },
    {
      id: 458,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb15102700001008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Stanmore
        </a>
      ),
      location: { lat: 51.593323, lng: -0.288075 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb15102700001008&product=HOURLY_RENTAL",
    },
    {
      id: 459,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902073006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Stevenage
        </a>
      ),
      location: { lat: 51.89, lng: -0.2 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902073006&product=HOURLY_RENTAL",
    },
    {
      id: 460,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901920003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Stockport
        </a>
      ),
      location: { lat: 53.41, lng: -2.17 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901920003&product=HOURLY_RENTAL",
    },
    {
      id: 461,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901967007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Stockton
        </a>
      ),
      location: { lat: 54.57, lng: -1.28 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901967007&product=HOURLY_RENTAL",
    },
    {
      id: 462,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082902082005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Sunderland
        </a>
      ),
      location: { lat: 54.91, lng: -1.39 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082902082005&product=HOURLY_RENTAL",
    },
    {
      id: 463,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901942007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Sutton
        </a>
      ),
      location: { lat: 51.36, lng: -0.18 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901942007&product=HOURLY_RENTAL",
    },
    {
      id: 464,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23030600003009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Sutton-In-Ashfield
        </a>
      ),
      location: { lat: 53.1316795, lng: -1.23719 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23030600003009&product=HOURLY_RENTAL",
    },
    {
      id: 465,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23020900002006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Swansea
        </a>
      ),
      location: { lat: 51.6443138, lng: -3.9324398 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23020900002006&product=HOURLY_RENTAL",
    },
    {
      id: 466,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901903004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Swindon
        </a>
      ),
      location: { lat: 51.56, lng: -1.8 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901903004&product=HOURLY_RENTAL",
    },
    {
      id: 467,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13072400002005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Sydenham
        </a>
      ),
      location: { lat: 51.42, lng: -0.03 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13072400002005&product=HOURLY_RENTAL",
    },
    {
      id: 468,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11102100001000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Tamworth
        </a>
      ),
      location: { lat: 52.62, lng: -1.7 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11102100001000&product=HOURLY_RENTAL",
    },
    {
      id: 470,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901922001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Wallasey
        </a>
      ),
      location: { lat: 53.41, lng: -3.07 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901922001&product=HOURLY_RENTAL",
    },
    {
      id: 471,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901914001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Warrington
        </a>
      ),
      location: { lat: 53.42, lng: -2.6 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901914001&product=HOURLY_RENTAL",
    },
    {
      id: 472,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901981009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Washington
        </a>
      ),
      location: { lat: 54.91, lng: -1.54 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901981009&product=HOURLY_RENTAL",
    },
    {
      id: 473,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901913002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Watford
        </a>
      ),
      location: { lat: 51.64, lng: -0.38 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901913002&product=HOURLY_RENTAL",
    },
    {
      id: 474,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb17030700002000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Welwyn
        </a>
      ),
      location: { lat: 51.800645, lng: -0.193144 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb17030700002000&product=HOURLY_RENTAL",
    },
    {
      id: 475,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901972000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q West Thurrock
        </a>
      ),
      location: { lat: 51.48, lng: 0.28 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901972000&product=HOURLY_RENTAL",
    },
    {
      id: 477,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901941008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Yeading
        </a>
      ),
      location: { lat: 51.52, lng: -0.38 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901941008&product=HOURLY_RENTAL",
    },
    {
      id: 478,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901982008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q York
        </a>
      ),
      location: { lat: 53.95, lng: -1.02 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901982008&product=HOURLY_RENTAL",
    },
    {
      id: 479,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121700002009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Aberdeen
        </a>
      ),
      location: { lat: 57.14, lng: -2.27 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121700002009&product=HOURLY_RENTAL",
    },
    {
      id: 480,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600001002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Birmingham
        </a>
      ),
      location: { lat: 52.5, lng: -1.85 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600001002&product=HOURLY_RENTAL",
    },
    {
      id: 481,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20102700001008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Bristol
        </a>
      ),
      location: { lat: 51.499604, lng: -2.691534 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20102700001008&product=HOURLY_RENTAL",
    },
    {
      id: 482,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19081200004003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Cardiff
        </a>
      ),
      location: { lat: 51.4709473, lng: -3.2030239 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19081200004003&product=HOURLY_RENTAL",
    },
    {
      id: 483,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121700003008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Chester
        </a>
      ),
      location: { lat: 53.24, lng: -2.93 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121700003008&product=HOURLY_RENTAL",
    },
    {
      id: 484,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600005008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Chingford
        </a>
      ),
      location: { lat: 51.61, lng: -0.03 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600005008&product=HOURLY_RENTAL",
    },
    {
      id: 485,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600004009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Coventry
        </a>
      ),
      location: { lat: 52.39, lng: -1.55 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600004009&product=HOURLY_RENTAL",
    },
    {
      id: 486,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600006007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Croydon
        </a>
      ),
      location: { lat: 51.35, lng: -0.11 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600006007&product=HOURLY_RENTAL",
    },
    {
      id: 487,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600013008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Derby
        </a>
      ),
      location: { lat: 52.91, lng: -1.44 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600013008&product=HOURLY_RENTAL",
    },
    {
      id: 488,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600014007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Edinburgh
        </a>
      ),
      location: { lat: 55.87, lng: -3.16 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600014007&product=HOURLY_RENTAL",
    },
    {
      id: 489,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600007006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Farnborough
        </a>
      ),
      location: { lat: 51.28, lng: -0.76 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600007006&product=HOURLY_RENTAL",
    },
    {
      id: 490,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600015006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Gateshead
        </a>
      ),
      location: { lat: 54.96, lng: -1.65 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600015006&product=HOURLY_RENTAL",
    },
    {
      id: 491,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600016005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Glasgow
        </a>
      ),
      location: { lat: 55.87, lng: -4.22 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600016005&product=HOURLY_RENTAL",
    },
    {
      id: 492,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600017004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Haydock
        </a>
      ),
      location: { lat: 53.47, lng: -2.66 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600017004&product=HOURLY_RENTAL",
    },
    {
      id: 493,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb14081900001002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Hayes
        </a>
      ),
      location: { lat: 51.49, lng: -0.4 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb14081900001002&product=HOURLY_RENTAL",
    },
    {
      id: 494,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600018003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Leeds
        </a>
      ),
      location: { lat: 53.78, lng: -1.53 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600018003&product=HOURLY_RENTAL",
    },
    {
      id: 495,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600008005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Leicester
        </a>
      ),
      location: { lat: 52.68, lng: -1.09 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600008005&product=HOURLY_RENTAL",
    },
    {
      id: 496,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600019002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Liverpool
        </a>
      ),
      location: { lat: 53.41, lng: -3 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600019002&product=HOURLY_RENTAL",
    },
    {
      id: 497,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600020009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Manchester
        </a>
      ),
      location: { lat: 53.46, lng: -2.34 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600020009&product=HOURLY_RENTAL",
    },
    {
      id: 498,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600009004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Milton Keynes
        </a>
      ),
      location: { lat: 52.03, lng: -0.68 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600009004&product=HOURLY_RENTAL",
    },
    {
      id: 499,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600021008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Oldham
        </a>
      ),
      location: { lat: 53.52, lng: -2.15 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600021008&product=HOURLY_RENTAL",
    },
    {
      id: 500,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600010001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Reading
        </a>
      ),
      location: { lat: 51.42, lng: -0.98 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600010001&product=HOURLY_RENTAL",
    },
    {
      id: 501,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121700004007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Sheffield
        </a>
      ),
      location: { lat: 53.38, lng: -1.42 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121700004007&product=HOURLY_RENTAL",
    },
    {
      id: 502,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600011000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Southampton
        </a>
      ),
      location: { lat: 50.91, lng: -1.43 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600011000&product=HOURLY_RENTAL",
    },
    {
      id: 503,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19071500001001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Stevenage
        </a>
      ),
      location: { lat: 51.9058065, lng: -0.2187761 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19071500001001&product=HOURLY_RENTAL",
    },
    {
      id: 504,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb15082400001009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Sunbury
        </a>
      ),
      location: { lat: 51.4227066, lng: -0.4141089 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb15082400001009&product=HOURLY_RENTAL",
    },
    {
      id: 505,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13121600012009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Thurrock
        </a>
      ),
      location: { lat: 51.48, lng: 0.28 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13121600012009&product=HOURLY_RENTAL",
    },
    {
      id: 506,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13083000004008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Watford
        </a>
      ),
      location: { lat: 51.66, lng: -0.36 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13083000004008&product=HOURLY_RENTAL",
    },
    {
      id: 507,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb16082200001001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Costco Wembley
        </a>
      ),
      location: { lat: 51.5564728, lng: -0.273086 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb16082200001001&product=HOURLY_RENTAL",
    },
    {
      id: 526,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19102800002007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Aberdeen
        </a>
      ),
      location: { lat: 57.1094797, lng: -2.0955891 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19102800002007&product=HOURLY_RENTAL",
    },
    {
      id: 527,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb14070700007003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Bristol
        </a>
      ),
      location: { lat: 51.47, lng: -2.56 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb14070700007003&product=HOURLY_RENTAL",
    },
    {
      id: 528,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb15020600003007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Cardiff
        </a>
      ),
      location: { lat: 51.4636803, lng: -3.1888261 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb15020600003007&product=HOURLY_RENTAL",
    },
    {
      id: 529,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb16112900001000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Croydon
        </a>
      ),
      location: { lat: 51.381331, lng: -0.124278 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb16112900001000&product=HOURLY_RENTAL",
    },
    {
      id: 530,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb14070700004006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Edinburgh
        </a>
      ),
      location: { lat: 55.88, lng: -3.16 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb14070700004006&product=HOURLY_RENTAL",
    },
    {
      id: 531,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18042400001002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Exeter
        </a>
      ),
      location: { lat: 50.7067375, lng: -3.4784789 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18042400001002&product=HOURLY_RENTAL",
    },
    {
      id: 532,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13083000005007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Gateshead
        </a>
      ),
      location: { lat: 54.95, lng: -1.68 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13083000005007&product=HOURLY_RENTAL",
    },
    {
      id: 533,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb14120100001002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Glasgow
        </a>
      ),
      location: { lat: 55.87, lng: -4.35 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb14120100001002&product=HOURLY_RENTAL",
    },
    {
      id: 534,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb15061900001003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Lakeside
        </a>
      ),
      location: { lat: 51.4804077, lng: 0.2857995 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb15061900001003&product=HOURLY_RENTAL",
    },
    {
      id: 535,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb14070700006004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Leeds
        </a>
      ),
      location: { lat: 53.74, lng: -1.65 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb14070700006004&product=HOURLY_RENTAL",
    },
    {
      id: 536,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb14050600001005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Manchester
        </a>
      ),
      location: { lat: 53.49, lng: -2.1 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb14050600001005&product=HOURLY_RENTAL",
    },
    {
      id: 537,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13103000003005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Milton Keynes
        </a>
      ),
      location: { lat: 52, lng: -0.72 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13103000003005&product=HOURLY_RENTAL",
    },
    {
      id: 538,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb15062400001003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Nottingham
        </a>
      ),
      location: { lat: 53.0017586, lng: -1.2822227 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb15062400001003&product=HOURLY_RENTAL",
    },
    {
      id: 539,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb16063000001008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Reading
        </a>
      ),
      location: { lat: 51.4416313, lng: -1.0648518 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb16063000001008&product=HOURLY_RENTAL",
    },
    {
      id: 540,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb17092600001008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Sheffield
        </a>
      ),
      location: { lat: 53.4073639, lng: -1.4092577 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb17092600001008&product=HOURLY_RENTAL",
    },
    {
      id: 541,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb15020600002008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Southampton
        </a>
      ),
      location: { lat: 50.9029503, lng: -1.4103049 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb15020600002008&product=HOURLY_RENTAL",
    },
    {
      id: 542,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb14070700005005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Warrington
        </a>
      ),
      location: { lat: 53.41, lng: -2.62 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb14070700005005&product=HOURLY_RENTAL",
    },
    {
      id: 543,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13103000001007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Wembley
        </a>
      ),
      location: { lat: 51.55, lng: -0.26 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13103000001007&product=HOURLY_RENTAL",
    },
    {
      id: 544,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22110400002000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Hertz 24/7 Brighton Branch
        </a>
      ),
      location: { lat: 50.8298732, lng: -0.1127601 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22110400002000&product=HOURLY_RENTAL",
    },
    {
      id: 545,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19090200001005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Hertz 24/7 Cambridge Branch
        </a>
      ),
      location: { lat: 52.1923997, lng: 0.1384558 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19090200001005&product=HOURLY_RENTAL",
    },
    {
      id: 546,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22110400003009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Hertz 24/7 Cardiff Branch
        </a>
      ),
      location: { lat: 51.4675998, lng: -3.1992487 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22110400003009&product=HOURLY_RENTAL",
    },
    {
      id: 547,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22110400001001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Hertz 24/7 Cheltenham Branch
        </a>
      ),
      location: { lat: 51.900905, lng: -2.15057 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22110400001001&product=HOURLY_RENTAL",
    },
    {
      id: 548,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23033100002008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Hertz 24/7 Dartford Branch
        </a>
      ),
      location: { lat: 51.4667186, lng: 0.18160586 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23033100002008&product=HOURLY_RENTAL",
    },
    {
      id: 549,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22033100001001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Hertz 24/7 Feltham Branch
        </a>
      ),
      location: { lat: 51.463138, lng: -0.392681 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22033100001001&product=HOURLY_RENTAL",
    },
    {
      id: 550,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19081900002000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Hertz 24/7 Manchester Piccadilly Branch
        </a>
      ),
      location: { lat: 53.4780083, lng: -2.2287476 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19081900002000&product=HOURLY_RENTAL",
    },
    {
      id: 551,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb21021000001009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Hertz 24/7 Oxford Branch
        </a>
      ),
      location: { lat: 51.748771, lng: -1.2756772 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb21021000001009&product=HOURLY_RENTAL",
    },
    {
      id: 552,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23020700002000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Hertz 24/7 Welwyn Garden City Branch
        </a>
      ),
      location: { lat: 51.7993252, lng: -0.1995842 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23020700002000&product=HOURLY_RENTAL",
    },
    {
      id: 553,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19092700002001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Apex Storage Cheadle
        </a>
      ),
      location: { lat: 53.358435, lng: -2.2039257 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19092700002001&product=HOURLY_RENTAL",
    },
    {
      id: 554,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22011100001007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Apex Storage Congleton
        </a>
      ),
      location: { lat: 53.1697369, lng: -2.2013306 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22011100001007&product=HOURLY_RENTAL",
    },
    {
      id: 555,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23041800002003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Apex Storage Glossop
        </a>
      ),
      location: { lat: 53.4603271, lng: -1.984729 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23041800002003&product=HOURLY_RENTAL",
    },
    {
      id: 557,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23092700002003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Brentwood
        </a>
      ),
      location: { lat: 51.6152532, lng: 0.290361 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23092700002003&product=HOURLY_RENTAL",
    },
    {
      id: 558,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23092700001004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Watford
        </a>
      ),
      location: { lat: 51.6807935, lng: -0.4012446 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23092700001004&product=HOURLY_RENTAL",
    },
    {
      id: 561,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19011000003003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Basingstoke
        </a>
      ),
      location: { lat: 51.2879594, lng: -1.0696928 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19011000003003&product=HOURLY_RENTAL",
    },
    {
      id: 562,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23022800001007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Bedford
        </a>
      ),
      location: { lat: 52.1308286, lng: -0.4573981 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23022800001007&product=HOURLY_RENTAL",
    },
    {
      id: 565,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19011000006000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Crawley
        </a>
      ),
      location: { lat: 51.1343109, lng: -0.1676252 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19011000006000&product=HOURLY_RENTAL",
    },
    {
      id: 566,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19011000007009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Crayford
        </a>
      ),
      location: { lat: 51.4622388, lng: 0.18995 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19011000007009&product=HOURLY_RENTAL",
    },
    {
      id: 567,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19011700001000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Dover
        </a>
      ),
      location: { lat: 51.1521797, lng: 1.30515516 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19011700001000&product=HOURLY_RENTAL",
    },
    {
      id: 568,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19061700001009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Exeter
        </a>
      ),
      location: { lat: 50.69524, lng: -3.5202422 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19061700001009&product=HOURLY_RENTAL",
    },
    {
      id: 569,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19011000009007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Fareham
        </a>
      ),
      location: { lat: 50.8621615, lng: -1.1684415 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19011000009007&product=HOURLY_RENTAL",
    },
    {
      id: 571,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19011000011003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Gillingham
        </a>
      ),
      location: { lat: 51.364905, lng: 0.579884 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19011000011003&product=HOURLY_RENTAL",
    },
    {
      id: 572,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22030900004004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Gloucester
        </a>
      ),
      location: { lat: 51.8612995, lng: -2.2247845 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22030900004004&product=HOURLY_RENTAL",
    },
    {
      id: 573,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18053000001006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Harlow
        </a>
      ),
      location: { lat: 51.783205, lng: 0.110443 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18053000001006&product=HOURLY_RENTAL",
    },
    {
      id: 574,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20120200001007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Hedge End
        </a>
      ),
      location: { lat: 50.9236238, lng: -1.309443 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20120200001007&product=HOURLY_RENTAL",
    },
    {
      id: 575,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18053000002005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Hemel Hempstead
        </a>
      ),
      location: { lat: 51.7553444, lng: -0.4381356 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18053000002005&product=HOURLY_RENTAL",
    },
    {
      id: 576,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19081200003004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Ipswich
        </a>
      ),
      location: { lat: 52.035183, lng: 1.20390904 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19081200003004&product=HOURLY_RENTAL",
    },
    {
      id: 577,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20092900001006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Leicester
        </a>
      ),
      location: { lat: 52.6191483, lng: -1.1343478 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20092900001006&product=HOURLY_RENTAL",
    },
    {
      id: 578,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18060100004002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Luton
        </a>
      ),
      location: { lat: 51.883902, lng: -0.40997 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18060100004002&product=HOURLY_RENTAL",
    },
    {
      id: 582,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18060100007009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Northampton Riverside
        </a>
      ),
      location: { lat: 52.2443886, lng: -0.8342574 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18060100007009&product=HOURLY_RENTAL",
    },
    {
      id: 583,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23020900001007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Oldbury
        </a>
      ),
      location: { lat: 52.4996977, lng: -2.0185506 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23020900001007&product=HOURLY_RENTAL",
    },
    {
      id: 589,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22061300002001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Stevenage
        </a>
      ),
      location: { lat: 51.8887273, lng: -0.2025655 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22061300002001&product=HOURLY_RENTAL",
    },
    {
      id: 591,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19011100003001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Swindon
        </a>
      ),
      location: { lat: 51.5766678, lng: -1.771248 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19011100003001&product=HOURLY_RENTAL",
    },
    {
      id: 592,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19011100004000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Tonbridge
        </a>
      ),
      location: { lat: 51.194332, lng: 0.284518 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19011100004000&product=HOURLY_RENTAL",
    },
    {
      id: 593,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22031100001003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Warrington
        </a>
      ),
      location: { lat: 53.396398, lng: -2.5933943 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22031100001003&product=HOURLY_RENTAL",
    },
    {
      id: 594,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18060100010004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Wellingborough
        </a>
      ),
      location: { lat: 52.2902756, lng: -0.6857309 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18060100010004&product=HOURLY_RENTAL",
    },
    {
      id: 595,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20111000003000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Magenta Self Storage Banbury
        </a>
      ),
      location: { lat: 52.0729942, lng: -1.317806 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20111000003000&product=HOURLY_RENTAL",
    },
    {
      id: 596,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20110900001004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Magenta Self Storage Chiswick
        </a>
      ),
      location: { lat: 51.499998, lng: -0.275022 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20110900001004&product=HOURLY_RENTAL",
    },
    {
      id: 597,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20111000004009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Magenta Self Storage Nottingham
        </a>
      ),
      location: { lat: 52.9435387, lng: -1.1333807 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20111000004009&product=HOURLY_RENTAL",
    },
    {
      id: 598,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23011300002000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Magenta Self Storage Reading
        </a>
      ),
      location: { lat: 51.4280156, lng: -0.975733 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23011300002000&product=HOURLY_RENTAL",
    },
    {
      id: 599,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20111000005008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Magenta Self Storage St Albans
        </a>
      ),
      location: { lat: 51.7676576, lng: -0.3210541 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20111000005008&product=HOURLY_RENTAL",
    },
    {
      id: 604,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19022200021004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Chester
        </a>
      ),
      location: { lat: 53.1938553, lng: -2.9117773 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19022200021004&product=HOURLY_RENTAL",
    },
    {
      id: 605,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18062200001001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Aylesford
        </a>
      ),
      location: { lat: 51.3046265, lng: 0.44913971 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18062200001001&product=HOURLY_RENTAL",
    },
    {
      id: 606,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18080700003006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Banbury
        </a>
      ),
      location: { lat: 52.072203, lng: -1.327459 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18080700003006&product=HOURLY_RENTAL",
    },
    {
      id: 607,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19022200003006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Basildon
        </a>
      ),
      location: { lat: 51.5835964, lng: 0.4658163 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19022200003006&product=HOURLY_RENTAL",
    },
    {
      id: 608,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23032300002005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Bath
        </a>
      ),
      location: { lat: 51.3807345, lng: -2.3897716 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23032300002005&product=HOURLY_RENTAL",
    },
    {
      id: 609,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19050700005008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Bedford
        </a>
      ),
      location: { lat: 52.147472, lng: -0.411669 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19050700005008&product=HOURLY_RENTAL",
    },
    {
      id: 610,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23041800001004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Blackpool
        </a>
      ),
      location: { lat: 53.7997578, lng: -3.009054 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23041800001004&product=HOURLY_RENTAL",
    },
    {
      id: 611,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19022200007002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Cambridge
        </a>
      ),
      location: { lat: 52.1956703, lng: 0.1719087 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19022200007002&product=HOURLY_RENTAL",
    },
    {
      id: 612,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19022200022003&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Crewe
        </a>
      ),
      location: { lat: 53.0877762, lng: -2.4303367 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19022200022003&product=HOURLY_RENTAL",
    },
    {
      id: 613,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19022200011006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Dartford
        </a>
      ),
      location: { lat: 51.438407, lng: 0.2458 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19022200011006&product=HOURLY_RENTAL",
    },
    {
      id: 614,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19022200015002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Derby
        </a>
      ),
      location: { lat: 52.923869, lng: -1.463421 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19022200015002&product=HOURLY_RENTAL",
    },
    {
      id: 615,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19022200018009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Doncaster
        </a>
      ),
      location: { lat: 53.508316, lng: -1.1197892 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19022200018009&product=HOURLY_RENTAL",
    },
    {
      id: 616,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb21102700003004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Dudley
        </a>
      ),
      location: { lat: 52.5168492, lng: -2.0664217 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb21102700003004&product=HOURLY_RENTAL",
    },
    {
      id: 617,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19022200012005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Dunstable
        </a>
      ),
      location: { lat: 51.8976026, lng: -0.5137206 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19022200012005&product=HOURLY_RENTAL",
    },
    {
      id: 618,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18070600002001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Epsom
        </a>
      ),
      location: { lat: 51.3406853, lng: -0.2633607 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18070600002001&product=HOURLY_RENTAL",
    },
    {
      id: 619,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19022200019008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Gloucester
        </a>
      ),
      location: { lat: 51.8657053, lng: -2.2110733 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19022200019008&product=HOURLY_RENTAL",
    },
    {
      id: 620,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22070800004007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Harrogate
        </a>
      ),
      location: { lat: 54.0046367, lng: -1.5494331 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22070800004007&product=HOURLY_RENTAL",
    },
    {
      id: 621,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19050700004009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King High Wycombe
        </a>
      ),
      location: { lat: 51.6316328, lng: -0.7658558 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19050700004009&product=HOURLY_RENTAL",
    },
    {
      id: 622,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22071300001000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Huddersfield
        </a>
      ),
      location: { lat: 53.6534926, lng: -1.776692 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22071300001000&product=HOURLY_RENTAL",
    },
    {
      id: 623,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18070600003000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Milton Keynes
        </a>
      ),
      location: { lat: 51.9847545, lng: -0.7301864 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18070600003000&product=HOURLY_RENTAL",
    },
    {
      id: 624,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20072100001007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Nottingham
        </a>
      ),
      location: { lat: 52.9729118, lng: -1.1745616 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20072100001007&product=HOURLY_RENTAL",
    },
    {
      id: 625,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18070600004009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Oxford
        </a>
      ),
      location: { lat: 51.7286973, lng: -1.1996809 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18070600004009&product=HOURLY_RENTAL",
    },
    {
      id: 626,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22062100002004&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Salisbury
        </a>
      ),
      location: { lat: 51.175118, lng: -1.7570025 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22062100002004&product=HOURLY_RENTAL",
    },
    {
      id: 627,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22070800002009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Wakefield
        </a>
      ),
      location: { lat: 53.6792123, lng: -1.4920619 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22070800002009&product=HOURLY_RENTAL",
    },
    {
      id: 628,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20073000001008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Warrington
        </a>
      ),
      location: { lat: 53.416161, lng: -2.599766 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20073000001008&product=HOURLY_RENTAL",
    },
    {
      id: 629,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19050700006007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Weybridge{" "}
        </a>
      ),
      location: { lat: 51.3499718, lng: -0.4769638 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19050700006007&product=HOURLY_RENTAL",
    },
    {
      id: 630,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18070600005008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Woodley Reading
        </a>
      ),
      location: { lat: 51.4544345, lng: -0.8951519 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18070600005008&product=HOURLY_RENTAL",
    },
    {
      id: 631,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb19022200020005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Worcester
        </a>
      ),
      location: { lat: 52.1968597, lng: -2.2072156 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb19022200020005&product=HOURLY_RENTAL",
    },
    {
      id: 632,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22070800003008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King York
        </a>
      ),
      location: { lat: 53.9835205, lng: -1.0948654 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22070800003008&product=HOURLY_RENTAL",
    },
    {
      id: 633,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22020400001000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Sure Store Ashton-Under-Lyne
        </a>
      ),
      location: { lat: 53.4884122, lng: -2.1147334 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22020400001000&product=HOURLY_RENTAL",
    },
    {
      id: 634,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20081700003001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Bolton
        </a>
      ),
      location: { lat: 53.5712173, lng: -2.4216497 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20081700003001&product=HOURLY_RENTAL",
    },
    {
      id: 635,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20081700007007&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Burton-On-Trent
        </a>
      ),
      location: { lat: 52.7906611, lng: -1.6694837 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20081700007007&product=HOURLY_RENTAL",
    },
    {
      id: 636,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20081700004000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Bury
        </a>
      ),
      location: { lat: 53.5756493, lng: -2.2731283 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20081700004000&product=HOURLY_RENTAL",
    },
    {
      id: 637,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20081700005009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Cannock
        </a>
      ),
      location: { lat: 52.6760405, lng: -2.0369721 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20081700005009&product=HOURLY_RENTAL",
    },
    {
      id: 638,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20081700009005&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Northwich
        </a>
      ),
      location: { lat: 53.2611601, lng: -2.5057597 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20081700009005&product=HOURLY_RENTAL",
    },
    {
      id: 639,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb21083100001002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Old Trafford
        </a>
      ),
      location: { lat: 53.458416, lng: -2.2954185 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb21083100001002&product=HOURLY_RENTAL",
    },
    {
      id: 640,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb20081700008006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Stafford
        </a>
      ),
      location: { lat: 52.837306, lng: -2.1351167 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb20081700008006&product=HOURLY_RENTAL",
    },
    {
      id: 641,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb21021000002008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Wigan
        </a>
      ),
      location: { lat: 53.5435147, lng: -2.6360706 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb21021000002008&product=HOURLY_RENTAL",
    },
    {
      id: 642,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22093000001000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Wokingham
        </a>
      ),
      location: { lat: 51.4051482, lng: -0.8465785 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22093000001000&product=HOURLY_RENTAL",
    },
    {
      id: 643,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23032300001006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore York
        </a>
      ),
      location: { lat: 53.9885106, lng: -1.0917539 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23032300001006&product=HOURLY_RENTAL",
    },
    {
      id: 644,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb22090700001008&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          The Self Storage Company Welwyn Garden City
        </a>
      ),
      location: { lat: 51.800243, lng: -0.1991314 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb22090700001008&product=HOURLY_RENTAL",
    },
    {
      id: 645,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb23020700001001&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          The Self Storage Company West Molesey
        </a>
      ),
      location: { lat: 51.3964932, lng: -0.3792193 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb23020700001001&product=HOURLY_RENTAL",
    },
    {
      id: 646,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=Gb-prk-Lens_Granton&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Len's Self Storage - Granton
        </a>
      ),
      location: { lat: 55.9814869063365, lng: -3.22449691810586 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=Gb-prk-Lens_Granton&product=HOURLY_RENTAL",
    },
    {
      id: 647,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=gb- prk-Lens_Hillington&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Len's Self Storage - Hillington
        </a>
      ),
      location: { lat: 55.86435, lng: -4.36948 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=gb- prk-Lens_Hillington&product=HOURLY_RENTAL",
    },
    {
      id: 648,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=gb-prk-Lens_Kinning_Park&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Len's Self Storage - Kinning Park
        </a>
      ),
      location: { lat: 55.8483781490017, lng: -4.29043615981958 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=gb-prk-Lens_Kinning_Park&product=HOURLY_RENTAL",
    },
    {
      id: 649,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=gb-prk-Lens_Sighthill&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Len's Self Storage - Sighthill
        </a>
      ),
      location: { lat: 55.9269799439315, lng: -3.29832040331951 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=gb-prk-Lens_Sighthill&product=HOURLY_RENTAL",
    },
    {
      id: 651,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Swindon&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Swindon
        </a>
      ),
      location: { lat: 51.5704311708134, lng: -1.8027222085974 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Swindon&product=HOURLY_RENTAL",
    },
    {
      id: 652,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Gillingham&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Gillingham
        </a>
      ),
      location: { lat: 51.3805090490485, lng: 0.577820593253837 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Gillingham&product=HOURLY_RENTAL",
    },
    {
      id: 653,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Dunstable&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Dunstable
        </a>
      ),
      location: { lat: 51.9027854086139, lng: -0.524421723940967 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Dunstable&product=HOURLY_RENTAL",
    },
    {
      id: 654,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_LeytonBuzzard&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Leyton Buzzard
        </a>
      ),
      location: { lat: 51.9091517997721, lng: -0.660322722089728 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_LeytonBuzzard&product=HOURLY_RENTAL",
    },
    {
      id: 655,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Sidcup&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Sidcup
        </a>
      ),
      location: { lat: 51.4142108371934, lng: 0.124240737433293 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Sidcup&product=HOURLY_RENTAL",
    },
    {
      id: 656,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Woking&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Woking
        </a>
      ),
      location: { lat: 51.3303524739805, lng: -0.529711422089728 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Woking&product=HOURLY_RENTAL",
    },
    {
      id: 657,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Newmarket&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Newmarket
        </a>
      ),
      location: { lat: 52.2582995357075, lng: 0.391153246167951 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Newmarket&product=HOURLY_RENTAL",
    },
    {
      id: 658,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_Bayswater&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Bayswater
        </a>
      ),
      location: { lat: 51.51661381, lng: -0.189007893 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_Bayswater&product=HOURLY_RENTAL",
    },
    {
      id: 659,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_Leyton&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Leyton
        </a>
      ),
      location: { lat: 51.56442734, lng: -0.030682754 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_Leyton&product=HOURLY_RENTAL",
    },
    {
      id: 660,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_Ashford&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Ashford
        </a>
      ),
      location: { lat: 51.13389728, lng: 0.868407078 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_Ashford&product=HOURLY_RENTAL",
    },
    {
      id: 661,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_Canterbury&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Canterbury
        </a>
      ),
      location: { lat: 51.29442421, lng: 1.107293007 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_Canterbury&product=HOURLY_RENTAL",
    },
    {
      id: 662,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_Frome&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Frome
        </a>
      ),
      location: { lat: 51.24382545, lng: -2.292594686 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_Frome&product=HOURLY_RENTAL",
    },
    {
      id: 663,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-storageking_hounslow&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Hounslow
        </a>
      ),
      location: { lat: 51.4714941835234, lng: -0.406209044976098 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-storageking_hounslow&product=HOURLY_RENTAL",
    },
    {
      id: 664,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Southport&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Southport
        </a>
      ),
      location: { lat: 53.63113, lng: -2.967796 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Southport&product=HOURLY_RENTAL",
    },
    {
      id: 665,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Gloucester&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Gloucester
        </a>
      ),
      location: { lat: 51.86044, lng: -2.24593 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Gloucester&product=HOURLY_RENTAL",
    },
    {
      id: 666,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Hampstead&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Hampstead, Birmingham
        </a>
      ),
      location: { lat: 52.5281656339868, lng: -1.92643661838724 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Hampstead&product=HOURLY_RENTAL",
    },
    {
      id: 667,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Stevenage&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Stevenage
        </a>
      ),
      location: { lat: 51.8880363887721, lng: -0.197092071210111 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Stevenage&product=HOURLY_RENTAL",
    },
    {
      id: 668,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Lincoln&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Lincoln
        </a>
      ),
      location: { lat: 53.2497743985545, lng: -0.587917635138153 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Lincoln&product=HOURLY_RENTAL",
    },
    {
      id: 670,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Stoke&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Stoke
        </a>
      ),
      location: { lat: 53.0323167670909, lng: -2.18938041086964 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Stoke&product=HOURLY_RENTAL",
    },
    {
      id: 671,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Theselfstoragecompany_Aston&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          The Self Storage Company, Aston
        </a>
      ),
      location: { lat: 52.4977248201478, lng: -1.88287906117616 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Theselfstoragecompany_Aston&product=HOURLY_RENTAL",
    },
    {
      id: 672,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-B&Q_Blackpool&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Blackpool
        </a>
      ),
      location: { lat: 53.791153, lng: -2.985126 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-B&Q_Blackpool&product=HOURLY_RENTAL",
    },
    {
      id: 673,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-SCA_Rotherham&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SCA Rotherham
        </a>
      ),
      location: { lat: 53.4285546226133, lng: -1.36493668980695 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-SCA_Rotherham&product=HOURLY_RENTAL",
    },
    {
      id: 674,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-SCASelfStorage_Sunderland&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SCA Sunderland
        </a>
      ),
      location: { lat: 54.914011677744, lng: -1.45480326047247 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-SCASelfStorage_Sunderland&product=HOURLY_RENTAL",
    },
    {
      id: 675,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Chippenham&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Chippenham
        </a>
      ),
      location: { lat: 51.44965469, lng: -2.136349478 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Chippenham&product=HOURLY_RENTAL",
    },
    {
      id: 676,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Eastwood&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Eastwood
        </a>
      ),
      location: { lat: 53.01780704, lng: -1.31782328 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Eastwood&product=HOURLY_RENTAL",
    },
    {
      id: 677,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Grimsby&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Grimsby
        </a>
      ),
      location: { lat: 53.56391056, lng: -0.07806538 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Grimsby&product=HOURLY_RENTAL",
    },
    {
      id: 678,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Halifax&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Halifax
        </a>
      ),
      location: { lat: 53.729182, lng: -1.873710776 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Halifax&product=HOURLY_RENTAL",
    },
    {
      id: 679,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Newport&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Newport
        </a>
      ),
      location: { lat: 51.57849212, lng: -2.966667934 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Newport&product=HOURLY_RENTAL",
    },
    {
      id: 680,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Taunton&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Taunton
        </a>
      ),
      location: { lat: 51.02313786, lng: -3.064885249 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Taunton&product=HOURLY_RENTAL",
    },
    {
      id: 681,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-bq_perth&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Perth
        </a>
      ),
      location: { lat: 56.4067, lng: -3.47867 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-bq_perth&product=HOURLY_RENTAL",
    },
    {
      id: 682,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-bq_basingstoke&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Basingstoke
        </a>
      ),
      location: { lat: 51.249355, lng: -1.115158 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-bq_basingstoke&product=HOURLY_RENTAL",
    },
    {
      id: 683,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-bq_norwich&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Norwich
        </a>
      ),
      location: { lat: 52.65667, lng: 1.27059 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-bq_norwich&product=HOURLY_RENTAL",
    },
    {
      id: 684,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-bq_exeter&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Exeter
        </a>
      ),
      location: { lat: 50.72783, lng: -3.46442 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-bq_exeter&product=HOURLY_RENTAL",
    },
    {
      id: 685,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb24041800001002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Staines
        </a>
      ),
      location: { lat: 51.432861, lng: -0.532404 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb24041800001002&product=HOURLY_RENTAL",
    },
    {
      id: 686,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Here_Loughborough&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Here Self Storage Loughborough
        </a>
      ),
      location: { lat: 52.773151631829, lng: -1.2137230865063 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Here_Loughborough&product=HOURLY_RENTAL",
    },
    {
      id: 687,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18062200002000&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Wednesbury
        </a>
      ),
      location: { lat: 52.5654335021972, lng: -2.00343060493469 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18062200002000&product=HOURLY_RENTAL",
    },
    {
      id: 688,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb11082901905002&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Wednesbury
        </a>
      ),
      location: { lat: 52.5678939819336, lng: -2.01371908187866 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb11082901905002&product=HOURLY_RENTAL",
    },
    {
      id: 689,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb13103000002006&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          IKEA Birmingham
        </a>
      ),
      location: { lat: 52.5706516519192, lng: -2.0150177343083 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb13103000002006&product=HOURLY_RENTAL",
    },
    {
      id: 690,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-NowStorage_Basingstoke&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Now Self Storage Basingstoke
        </a>
      ),
      location: { lat: 51.2698933502573, lng: -1.09812895250042 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-NowStorage_Basingstoke&product=HOURLY_RENTAL",
    },
    {
      id: 691,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Tunbridge&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Tunbridge Wells
        </a>
      ),
      location: { lat: 51.1515428486372, lng: 0.278826381955381 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Tunbridge&product=HOURLY_RENTAL",
    },
    {
      id: 692,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Torquay&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Torquay
        </a>
      ),
      location: { lat: 50.4817670134238, lng: -3.54883534232874 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Torquay&product=HOURLY_RENTAL",
    },
    {
      id: 693,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_Chatham&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Chatham
        </a>
      ),
      location: { lat: 51.32967, lng: 0.54217 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_Chatham&product=HOURLY_RENTAL",
    },
    {
      id: 694,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Shurgard_Bromborough&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Bromborough
        </a>
      ),
      location: { lat: 53.3383196607011, lng: -2.97634666136609 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Shurgard_Bromborough&product=HOURLY_RENTAL",
    },
    {
      id: 695,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Hamstead&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Surestore Hamstead
        </a>
      ),
      location: { lat: 52.5281656339868, lng: -1.92643661838724 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Hamstead&product=HOURLY_RENTAL",
    },
    {
      id: 696,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Shurgard_Chichester&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Chichester
        </a>
      ),
      location: { lat: 50.8322381101071, lng: -0.793798635582054 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Shurgard_Chichester&product=HOURLY_RENTAL",
    },
    {
      id: 697,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Shurgard_Peterborough&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Peterborough
        </a>
      ),
      location: { lat: 52.5920392938767, lng: -0.258512130028335 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Shurgard_Peterborough&product=HOURLY_RENTAL",
    },
    {
      id: 698,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Shurgard_Barking&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Barking
        </a>
      ),
      location: { lat: 51.5275958978205, lng: 0.0794589834639901 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Shurgard_Barking&product=HOURLY_RENTAL",
    },
    {
      id: 699,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Shurgard_KentishTown&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Kentish Town
        </a>
      ),
      location: { lat: 51.5528453555634, lng: -0.142807889551357 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Shurgard_KentishTown&product=HOURLY_RENTAL",
    },
    {
      id: 700,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Shurgard_Hayes&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Hayes
        </a>
      ),
      location: { lat: 51.514108815046, lng: -0.390389572026125 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Shurgard_Hayes&product=HOURLY_RENTAL",
    },
    {
      id: 701,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-bq_Altrincham&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Altrincham
        </a>
      ),
      location: { lat: 53.4003297333651, lng: -2.3539279007208 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-bq_Altrincham&product=HOURLY_RENTAL",
    },
    {
      id: 702,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Shurgard_Wokingham&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Shurgard Wokingham
        </a>
      ),
      location: { lat: 51.4079717797737, lng: -0.847624987399721 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Shurgard_Wokingham&product=HOURLY_RENTAL",
    },
    {
      id: 703,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-NowStorage_Cardiff&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Now Self Storage Cardiff
        </a>
      ),
      location: { lat: 51.4802928168601, lng: -3.15473661349385 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-NowStorage_Cardiff&product=HOURLY_RENTAL",
    },
    {
      id: 704,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-NowStorage_Cheltenham&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Now Self Storage Cheltenham
        </a>
      ),
      location: { lat: 51.917278428025, lng: -2.10995922972433 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-NowStorage_Cheltenham&product=HOURLY_RENTAL",
    },
    {
      id: 705,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prks-gb-Marriott_LHR&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Marriott Hotel - London Heathrow
        </a>
      ),
      location: { lat: 51.48166, lng: -0.43813 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prks-gb-Marriott_LHR&product=HOURLY_RENTAL",
    },
    {
      id: 706,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-NowStorage_Hereford&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Now Storage Hereford
        </a>
      ),
      location: { lat: 52.0688091707902, lng: -2.73778114192202 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-NowStorage_Hereford&product=HOURLY_RENTAL",
    },
    {
      id: 707,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Access_Balham&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Access Self Storage Balham
        </a>
      ),
      location: { lat: 51.4431985, lng: -0.1547494 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Access_Balham&product=HOURLY_RENTAL",
    },
    {
      id: 708,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb18121200002009&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Access Self Storage Bracknell
        </a>
      ),
      location: { lat: 51.4098207, lng: -0.7664475 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb18121200002009&product=HOURLY_RENTAL",
    },
    {
      id: 709,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Access_HighWycombe&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Access Self Storage High Wycombe
        </a>
      ),
      location: { lat: 51.6137911999999, lng: -0.7658181 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Access_HighWycombe&product=HOURLY_RENTAL",
    },
    {
      id: 710,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Harringay&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Harringay
        </a>
      ),
      location: { lat: 51.5758149, lng: -0.0980072999999999 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Harringay&product=HOURLY_RENTAL",
    },
    {
      id: 711,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Christchurch&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Christchurch
        </a>
      ),
      location: { lat: 50.7379297, lng: -1.7673712 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Christchurch&product=HOURLY_RENTAL",
    },
    {
      id: 712,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=gb-prk-BQ-Falkirk&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Falkirk
        </a>
      ),
      location: { lat: 56.0099728, lng: -3.7669009 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=gb-prk-BQ-Falkirk&product=HOURLY_RENTAL",
    },
    {
      id: 713,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Castlepoint&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Bournemouth, Castle Point
        </a>
      ),
      location: { lat: 50.7525811, lng: -1.8392598 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Castlepoint&product=HOURLY_RENTAL",
    },
    {
      id: 714,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Stirling&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Stirling
        </a>
      ),
      location: { lat: 56.1126741, lng: -3.9117074 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Stirling&product=HOURLY_RENTAL",
    },
    {
      id: 715,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Huntingdon&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Huntingdon
        </a>
      ),
      location: { lat: 52.3530903, lng: -0.1836078 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Huntingdon&product=HOURLY_RENTAL",
    },
    {
      id: 716,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Keighley&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Keighley
        </a>
      ),
      location: { lat: 53.8748359, lng: -1.895831 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Keighley&product=HOURLY_RENTAL",
    },
    {
      id: 717,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Carlisle&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Carlisle
        </a>
      ),
      location: { lat: 54.8852676, lng: -2.9158845 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Carlisle&product=HOURLY_RENTAL",
    },
    {
      id: 718,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Paulton&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Paulton
        </a>
      ),
      location: { lat: 51.2924497, lng: -2.5003258 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Paulton&product=HOURLY_RENTAL",
    },
    {
      id: 719,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Shorham&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Shoreham
        </a>
      ),
      location: { lat: 50.8324688999999, lng: -0.2635553 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Shorham&product=HOURLY_RENTAL",
    },
    {
      id: 720,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Newbury&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Newbury
        </a>
      ),
      location: { lat: 51.4024789, lng: -1.3188926 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Newbury&product=HOURLY_RENTAL",
    },
    {
      id: 721,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Newcastle&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Newcastle upon Tyne
        </a>
      ),
      location: { lat: 54.966008, lng: -1.6946512 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Newcastle&product=HOURLY_RENTAL",
    },
    {
      id: 722,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Earlsfield&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Earlsfield
        </a>
      ),
      location: { lat: 51.4332734, lng: -0.1847659 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Earlsfield&product=HOURLY_RENTAL",
    },
    {
      id: 723,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=gb-prk-BQ-TP-Barking&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Trade Point Barking
        </a>
      ),
      location: { lat: 51.5321878, lng: 0.1103617 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=gb-prk-BQ-TP-Barking&product=HOURLY_RENTAL",
    },
    {
      id: 724,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_WestBromwich&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King West Bromwich, Swan Village
        </a>
      ),
      location: { lat: 52.5279816, lng: -2.0179201 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_WestBromwich&product=HOURLY_RENTAL",
    },
    {
      id: 725,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Chester&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          SureStore Chester
        </a>
      ),
      location: { lat: 53.1964133, lng: -2.9076006 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-SureStore_Chester&product=HOURLY_RENTAL",
    },
    {
      id: 726,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_Chelmsford&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Storage King Chelmsford
        </a>
      ),
      location: { lat: 51.7387467, lng: 0.475468699999999 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-StorageKing_Chelmsford&product=HOURLY_RENTAL",
    },
    {
      id: 727,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_WestNorwood&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q West Norwood
        </a>
      ),
      location: { lat: 51.4354677, lng: -0.1043736 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_WestNorwood&product=HOURLY_RENTAL",
    },
    {
      id: 728,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_EstrehamRoad&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Lambeth On Street - Hertz 24/7 Estreham Road, Lambeth
        </a>
      ),
      location: { lat: 51.41928487, lng: -0.1366894 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_EstrehamRoad&product=HOURLY_RENTAL",
    },
    {
      id: 729,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_AbercairnRd&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Lambeth On Street - Hertz 24/7 Abercairn Road, Lambeth
        </a>
      ),
      location: { lat: 51.4135896, lng: -0.1432119 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_AbercairnRd&product=HOURLY_RENTAL",
    },
    {
      id: 730,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_BeechdaleRoad&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Lambeth On Street - Hertz 24/7 Beechdale Road, Lambeth
        </a>
      ),
      location: { lat: 51.4520728, lng: -0.1193007 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_BeechdaleRoad&product=HOURLY_RENTAL",
    },
    {
      id: 731,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_CrescentLane&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Lambeth On Street - Hertz 24/7 Crescent Lane, Lambeth
        </a>
      ),
      location: { lat: 51.4576446, lng: -0.1346332 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_CrescentLane&product=HOURLY_RENTAL",
    },
    {
      id: 732,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_GraftonSquare&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Lambeth On Street - Hertz 24/7 Grafton Square, Lambeth
        </a>
      ),
      location: { lat: 51.4646307, lng: -0.1394083 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_GraftonSquare&product=HOURLY_RENTAL",
    },
    {
      id: 733,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_IvymountRoad&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Lambeth On Street - Hertz 24/7 Ivymount Road, Lambeth
        </a>
      ),
      location: { lat: 51.4329057, lng: -0.1129159 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_IvymountRoad&product=HOURLY_RENTAL",
    },
    {
      id: 734,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_OffleyRoad&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Lambeth On Street - Hertz 24/7 Offley Road, Lambeth
        </a>
      ),
      location: { lat: 51.4800247, lng: -0.1129036 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_OffleyRoad&product=HOURLY_RENTAL",
    },
    {
      id: 735,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_ParkHallRoad&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Lambeth On Street - Hertz 24/7 Park Hall Road, Lambeth
        </a>
      ),
      location: { lat: 51.4363641, lng: -0.0894897 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_ParkHallRoad&product=HOURLY_RENTAL",
    },
    {
      id: 736,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=Prkl-gb-HZL_PentneyRd&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Lambeth On Street - Hertz 24/7 Pentney Road, Lambeth
        </a>
      ),
      location: { lat: 51.4430309, lng: -0.1419858 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=Prkl-gb-HZL_PentneyRd&product=HOURLY_RENTAL",
    },
    {
      id: 737,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_TalmaRoad&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Lambeth On Street - Hertz 24/7 Talma Road, Lambeth
        </a>
      ),
      location: { lat: 51.4602572999999, lng: -0.1113769 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prkl-gb-HZL_TalmaRoad&product=HOURLY_RENTAL",
    },
    {
      id: 738,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Mitcham&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          Cinch Self Storage Mitcham
        </a>
      ),
      location: { lat: 51.4134228, lng: -0.1551763 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-Cinch_Mitcham&product=HOURLY_RENTAL",
    },
    {
      id: 739,
      name: (
        <a
          href="https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Redditch&product=HOURLY_RENTAL"
          style={{ textDecoration: "none", color: "black" }}
        >
          B&Q Redditch
        </a>
      ),
      location: { lat: 52.30101, lng: -1.934936 },
      ufoUrl:
        "https://booking.hertz247.com/booking/book?location=prk-gb-BQ_Redditch&product=HOURLY_RENTAL",
    },
  ];

  return (
    isLoaded && (
      <>
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={7}
          onLoad={(map) => {
            mapRef.current = map;
          }}
          options={{
            streetViewControl: false,
            mapTypeControl: false,
          }}
        >
          {points.map((point) => {
            return (
              <div key={point.id}>
                <Marker
                  position={point.location}
                  options={{
                    icon: "https://images.hertz.com/content/dam/hod/images/en-gb/static/Location_Pin.png",
                  }}
                  onClick={() => panToMarker(point)}
                />
              </div>
            );
          })}
          {selectedMarker && (
            <InfoWindow
              position={selectedMarker.location}
              options={{
                disableAutoPan: true,
                pixelOffset: new window.google.maps.Size(0, -40),
              }}
              onCloseClick={closeInfoWindow}
            >
              <>
                <h6>{selectedMarker.name}</h6>
                <button
                  className="btn btn-warning"
                  onClick={() => (window.location.href = selectedMarker.ufoUrl)}
                >
                  Book Now
                </button>
              </>
            </InfoWindow>
          )}
        </GoogleMap>
      </>
    )
  );
};

export default Map;
